import { atomWithReset } from 'jotai/utils'

export const SPUDataAtom = atomWithReset({
  dataSource: [],
  chooseSku: [],
});